const files = require.context("./pages", true, /\.vue$/);
const modules = [];
files.keys().forEach(key => {
  if (files(key).default === undefined) {
    throw Error(`Cannot find component in file ${key}`);
  }
  modules.push(files(key).default);
});
export default modules;
